import { tv } from "../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
const dialogVariants = tv({
  slots: {
    content: `
      z-50 top-1/2 left-1/2 grid w-full sm:max-w-lg p-6 gap-4
      bg-(--white) dark:bg-(--gray-bg-1) rounded-lg shadow-lg duration-200 -translate-1/2
        data-[state=open]:animate-in    data-[state=open]:fade-in-0    data-[state=open]:zoom-in-95
      data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95
    `,
    closeIcon: `
      absolute top-4 right-4
      rounded-xs opacity-70 transition-opacity hover:opacity-100 disabled:pointer-events-none
      [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4
      focus:ring-(--gray-border-1) focus:ring-[3px] focus:ring-offset-2 focus:outline-hidden
    `,
    footer: "flex-col-reverse sm:flex-row sm:justify-end",
    header: "flex-col text-center sm:text-left",
    overlay: "fixed z-50 inset-0 bg-black/80 data-[state=open]:fade-in-0 data-[state=closed]:fade-out-0"
  },
  variants: {
    isScrollable: {
      true: {
        overlay: "grid place-items-center overflow-y-auto",
        content: "relative max-w-lg my-8 sm:rounded-lg md:w-full"
      },
      false: {
        content: "fixed max-w-[calc(100%-2rem)]"
      }
    },
    allowDrag: {
      true: {
        content: "cursor-move"
      },
      false: {}
    }
  },
  compoundSlots: [
    { slots: ["footer", "header"], class: "flex gap-2" }
  ],
  defaultVariants: {
    isScrollable: !1,
    allowDrag: !1
  }
});
export {
  dialogVariants
};
//# sourceMappingURL=variants.js.map
